import api from "./api";

const BASE = "/api/settings/policy";

const getAll = () => api.get(BASE);

/**
 * Lightweight policy list for the Edit Member drawer — ungated (no
 * iam:readPolicy); returns id/name plus role ids only.
 */
const getForAssign = () => api.get(`${BASE}/for-assign`);

const getOne = (id) => api.get(`${BASE}/${id}`);

const create = (payload) => api.post(BASE, payload);

const update = (id, payload) => api.put(`${BASE}/${id}`, payload);

const remove = (id) => api.delete(`${BASE}/${id}`);

/** Attach this policy to a set of roles (replaces the current set). */
const assignToRoles = (id, roleIds) => api.post(`${BASE}/${id}/roles`, { roleIds });

/** Attach this policy directly to a set of users (replaces the current set). */
const assignToUsers = (id, userIds) => api.post(`${BASE}/${id}/users`, { userIds });

const PolicyService = {
  getAll,
  getForAssign,
  getOne,
  create,
  update,
  remove,
  assignToRoles,
  assignToUsers,
};

export default PolicyService;
